var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingEmoji4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#F8CD5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6041 32.8068C14.6666 33.0554 16.2263 38.8888 24.9999 38.8888C33.7749 38.8888 35.3332 33.0554 35.3957 32.8068C35.4721 32.5054 35.336 32.1929 35.0666 32.0374C34.7957 31.8832 34.4568 31.9291 34.2332 32.1443C34.2068 32.1707 31.5193 34.7221 24.9999 34.7221C18.4805 34.7221 15.7916 32.1707 15.7666 32.1457C15.6332 32.0138 15.4555 31.9443 15.2777 31.9443C15.161 31.9443 15.043 31.9735 14.936 32.0332C14.6638 32.1888 14.5277 32.5041 14.6041 32.8068Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 23.6109C18.5842 23.6109 20.1388 21.4345 20.1388 18.7498C20.1388 16.0651 18.5842 13.8887 16.6666 13.8887C14.7489 13.8887 13.1943 16.0651 13.1943 18.7498C13.1943 21.4345 14.7489 23.6109 16.6666 23.6109Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 23.6109C35.251 23.6109 36.8055 21.4345 36.8055 18.7498C36.8055 16.0651 35.251 13.8887 33.3333 13.8887C31.4157 13.8887 29.8611 16.0651 29.8611 18.7498C29.8611 21.4345 31.4157 23.6109 33.3333 23.6109Z",
    fill: "#664500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingEmoji4);
export default __webpack_public_path__ + "static/media/rating_emoji_4.4a4ed174330d5d63afe845464c037ba3.svg";
export { ForwardRef as ReactComponent };